window.theme = window.theme || {};

/* ================ SLATE ================ */

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on("shopify:section:load", this._onSectionLoad.bind(this))
    .on("shopify:section:unload", this._onSectionUnload.bind(this))
    .on("shopify:section:select", this._onSelect.bind(this))
    .on("shopify:section:deselect", this._onDeselect.bind(this))
    .on("shopify:block:select", this._onBlockSelect.bind(this))
    .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr("data-section-id");
    var type = $container.attr("data-section-type");

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $("[data-section-id]", evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $("[data-section-type=" + type + "]").each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  wrapTable: function() {
    $(".rte table").wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $(
      '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'
    );
    var $iframeReset = $iframeVideo.add(".rte iframe#admin_bar_iframe");

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = "js-focus-hidden";

    $element
      .first()
      .attr("tabIndex", "-1")
      .focus()
      .addClass(focusClass)
      .one("blur", callback);

    function callback() {
      $element
        .first()
        .removeClass(focusClass)
        .removeAttr("tabindex");
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $("a[href*=#]").on(
      "click",
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr("tabindex", "-1");
    options.$elementToFocus.focus();

    $(document).off("focusin");

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (options.$container && options.$container.length) {
      options.$container.removeAttr("tabindex");
    }

    $(document).off(eventName);
  }
};

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = "${{amount}}"; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(
      number,
      precision,
      thousands,
      decimal,
      noTrailingZeros
    ) {
      precision = precision || 2;
      thousands = thousands || ",";
      decimal = decimal || ".";

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      if (parts[1] == "00" && noTrailingZeros) {
        return dollarsAmount;
      } else {
        return dollarsAmount + centsAmount;
      }
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_trailing_zeros":
        value = formatWithDelimiters(cents, 2, ",", ".", true);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      "change",
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function(element) {
          var $element = $(element);
          var type = $element.attr("type");
          var currentOption = {};

          if (type === "radio" || type === "checkbox") {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data("index");

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data("index");

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: "variantChange",
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantImageChange",
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantPriceChange",
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: "variantSKUChange",
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?variant=" +
        variant.id;
      window.history.replaceState({ path: newurl }, "", newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();

/* ================ Custom Helpers ================ */

/**
 * API Helpers
 * --------------------------
 */

if (typeof ShopifyAPI === "undefined") {
  ShopifyAPI = {};
}

ShopifyAPI.getProducts = function(url, callback) {
  jQuery
    .getJSON(url, null, null)
    .done(function(data) {
      if (callback) {
        callback(data);
      }
    })
    .fail(function(jqXHR, textStatus) {
      ShopifyAPI.onError(jqXHR, textStatus);
    })
    .always(function() {
      // console.log("Finished getting products!");
    });
};

/**
 * String Helpers
 * ----------------------------
 */

theme.Handleize = function(str) {
  return str
    .toLowerCase()
    .replace(/[^\w\u00C0-\u024f]+/g, "-")
    .replace(/^-+|-+$/g, "");
};

/**
 * Linear Data Helper
 * --------------------------
 * Linear data flow
 *
 */

theme.Line = (function(value) {
  function Line(value) {
    this.value = value;
  }

  Line.prototype = _.assignIn({}, Line.prototype, {
    copy: function() {
      if (Array.isArray(this.value)) {
        return this.value.slice();
      } else if (typeof this.value == "string") {
        return this.value;
      }
    },

    then: function(f) {
      return new theme.Line(f(this.value));
    },

    prepend: function(item) {
      if (Array.isArray(this.value)) {
        this.value.unshift(item);
      } else if (typeof this.value == "string") {
        this.value = item + this.value;
      }

      return new theme.Line(this.value);
    },

    remove: function(item) {
      if (Array.isArray(this.value)) {
        var index = this.value.indexOf(item);
        this.value.splice(index, 1);
      } else if (typeof this.value == "string") {
        this.value = this.value.split(item).join("");
      }

      return new theme.Line(this.value);
    },

    // string

    toString: function() {
      return new theme.Line(this.value.toString());
    },

    toLowerCase: function() {
      return new theme.Line(this.value.toLowerCase());
    },

    split: function(spliter) {
      return new theme.Line(this.value.split(spliter));
    },

    concat: function(str) {
      return new theme.Line(this.value.concat(str));
    },

    // array
    map: function(f) {
      this.value = this.value.map(f);
      return new theme.Line(this.value);
    },

    join: function(joiner) {
      this.value = this.value.join(joiner);
      return new theme.Line(this.value);
    },

    push: function(item) {
      this.value.push(item);
      return new theme.Line(this.value);
    },

    pop: function() {
      this.value.pop();
      return new theme.Line(this.value);
    },

    shift: function() {
      this.value.shift();
      return new theme.Line(this.value);
    },

    unshift: function(items) {
      this.value.unshift(items);
      return new theme.Line(this.value);
    },

    first: function() {
      var value = this.value.splice(0, 1);
      return new theme.Line(value);
    },

    last: function() {
      var value = this.value.splice(-1);
      return new Line(value);
    },

    splice: function(index, count, item) {
      if (!item) {
        var value = this.value.splice(index, count);
      } else {
        var value = this.value.splice(index, count, item);
      }

      return new theme.Line(value);
    },

    insert: function(index, item) {
      var value = this.value.splice(index, 0, item);
      return new theme.Line(value);
    },

    deArray: function() {
      return new theme.Line(this.value[0]);
    },

    fold: function() {
      return this.value;
    }
  });

  return Line;
})();

/**
 * Date Helper
 * --------------------------
 */

theme.Date = (function(value) {
  // Private variables
  var millisecondsPerSec = 1000,
    millisecondsPerMin = 60 * 1000,
    millisecondsPerHour = 60 * 60 * 1000,
    millisecondsPerDay = 24 * 60 * 60 * 1000,
    millisecondsPerMonth = 30 * millisecondsPerDay,
    millisecondsPerYear = 12 * millisecondsPerMonth;

  // Previous functions
  var toUTC, getTimeDist, getTimeSpan, reset, legalize, getTomorrow;

  toUTC = function(date) {
    date.setTime(
      date.getTime() + date.getTimezoneOffset() * millisecondsPerMin
    );
    return date;
  };

  // previous functions
  getTimeDist = function(startDate, endDate, unit, getLegalTime) {
    var unit = !unit ? "milliseconds" : unit.toLowerCase(),
      // millisecondsPerDay = 24 * 60 * 60 * 1000,
      // millisecondsPerMonth = 30 * millisecondsPerDay,
      // millisecondsPerYear = 12 * millisecondsPerMonth,
      millisecondsSpan = toUTC(endDate) - toUTC(startDate),
      result = {
        unti: unit,
        value: 0
      };

    switch (unit) {
      case "year":
        result.value = Math.floor(millisecondsSpan / millisecondsPerYear); // years
        break;
      case "month":
        result.value = Math.floor(millisecondsSpan / millisecondsPerMonth); // months
        break;
      case "day":
        result.value = Math.floor(millisecondsSpan / millisecondsPerDay); // days
        break;
      case "hour":
        result.value = Math.floor(millisecondsSpan / millisecondsPerHour); // hours
        break;
      case "minute":
        result.value = Math.floor(millisecondsSpan / millisecondsPerMin); // minutes
        break;
      case "second":
        result.value = Math.floor(millisecondsSpan / millisecondsPerSec); // seconds
      default:
        result.value = millisecondsSpan; // milliseconds
    }

    if (getLegalTime) {
      result.value = legalize(result.value);
    }

    return result;
  };

  reset = function(date) {
    var year = date.getFullYear(),
      month = new theme.Line(date.getMonth() + 1).then(legalize).fold(),
      day = new theme.Line(date.getDate()).then(legalize).fold(),
      dateStr = [month, day, year].join("/");

    return new Date(dateStr);
  };

  legalize = function(num) {
    return parseInt(num) >= 10 ? num : "0" + num;
  };

  getTomorrow = function(date) {
    return new Date(date.getTime() + millisecondsPerDay * 1);
  };

  return {
    toUTC: toUTC,
    getTimeSpan: getTimeSpan,
    getTimeDist: getTimeDist,
    getTomorrow: getTomorrow,
    reset: reset,
    legalize: legalize
  };
})();

/**
 * Local Storage Helper
 * --------------------------
 */

theme.Storage = (function() {
  var set = function(key, value, expiration) {
    var _value = {
      value: value,
      expiration: expiration,
      createdAt: new Date()
    };

    localStorage.setItem(key, JSON.stringify(_value));
  };

  var get = function(key) {
    // _value saved as string
    var _valueRaw = localStorage.getItem(key);

    if (!_valueRaw) {
      // when item doesn't exist
      console.log("Item doesn't exist!");
      return undefined;
    } else {
      // when item exist
      var _value = JSON.parse(_valueRaw);

      if (!_value.expiration) {
        // if doesn't have an expiration date
        return _value.value;
      } else {
        // check expiration
        if (new Date(_value.expiration) > new Date()) {
          return _value.value;
        } else {
          this.remove(key);
          console.log("This item is expired!");
          return undefined;
        }
      }
    }
  };

  var remove = function(key) {
    return localStorage.removeItem(key);
  };

  var checkExpiration = function(key) {
    // _value saved as string
    var _valueRaw = localStorage.getItem(key);

    if (!_valueRaw) {
      console.log("Item doesn't exist!");
      return undefined;
    } else {
      var expiration = JSON.parse(_valueRaw).expiration;
      if (!expiration) {
        console.log("This item doesn't have expiration date!");
        return undefined;
      } else {
        var isExpired = new Date(expiration) > new Date() ? false : true;
        return isExpired;
      }
    }
  };

  return {
    set: set,
    get: get,
    remove: remove,
    checkExpiration: checkExpiration
  };
})();

/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var defaults = {
      close: ".js-drawer-close-" + position,
      open: ".js-drawer-open-" + position,
      openClass: "js-drawer-open",
      dirOpenClass: "js-drawer-open-" + position
    };

    this.nodes = {
      $parent: $("html").add("body"),
      $page: $("#PageContainer"),
      $mobileClose: $(".js-mobile-nav__close"),
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $("#" + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.open).on("click", $.proxy(this.open, this));
    $(this.config.close).on("click", $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + " " + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: "drawer_focus"
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === "function"
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr("aria-expanded")) {
      this.$activeSource.attr("aria-expanded", "true");
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function(evt) {
    // console.log($(evt.target));
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger("blur");

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + " " + this.config.openClass
    );

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: "drawer_focus"
    });

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on(
      "keyup.drawer",
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on("touchmove.drawer", function() {
//Commented to fix the menu scroll issue      return false;
    });

    this.nodes.$mobileClose.on(
      "click.drawer",
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off(".drawer");
    this.nodes.$parent.off(".drawer");
  };

  return Drawer;
})();

/*============================================================================
  Modal
==============================================================================*/
theme.Modal = (function() {
  var init, open, close, bindEvents, off;

  var selectors = {
    modal: ".modal",
    modalInner: ".modal-inner",
    modalOpen: ".js-modal-open",
    modalClose: ".js-modal-close"
  };

  var cache = {
    $modal: $(selectors.modal),
    $modalInner: $(selectors.modalInner),
    $modalOpen: $(selectors.modalOpen),
    $modalClose: $(selectors.modalClose)
  };

  var classes = {
    activeModal: "modal--is-active"
  };

  init = function() {
    cache.$modalOpen.on("click.modal", open);
    cache.$modal.on("click.modal", close);
    bindEvents();
  };

  open = function(evt) {
    var $this = $(evt.target),
      target = $this.data("target"),
      $modal = $(target);

    $modal.addClass(classes.activeModal);
  };

  close = function(evt) {
    var onESC = evt.keyCode ? true : false,
      $this = $(evt.target),
      $modal = onESC
        ? $("." + classes.activeModal)
        : $this.closest("." + classes.activeModal);

    if (
      $this.hasClass("modal-inner") ||
      $this.hasClass("js-modal-close") ||
      onESC
    ) {
      $modal.removeClass(classes.activeModal);
    }
  };

  bindEvents = function() {
    $(document).on("keyup.modal", function(evt) {
      // close on 'esc' keypress
      if (evt.keyCode === 27) {
        close(evt);
        return false;
      } else {
        return true;
      }
    });
  };

  off = function() {
    cache.$modalOpen.off(".modal");
    cache.$modal.off(".modal");
    $(document).off(".modal");
  };

  return {
    init: init,
    off: off
  };
})();

/*============================================================================
  Collapse
==============================================================================*/
theme.Collapse = (function() {
  function Collapse(selector, event, time, cb) {
    this.$collapseToggle = $(selector);
    this._init(event, time, cb);
  }

  Collapse.prototype._init = function(event, time, cb) {
    this.$collapseToggle.on(event, function(evt) {
      time = time ? time : 500;
      evt.stopPropagation();
      evt.preventDefault();

      var $this = $(this);
      var $collapseBody = $this.siblings(".collapse-bd");

      if ($collapseBody.length == 0) {
        $collapseBody = $this.parent().siblings(".collapse-bd");
      }

      function switchToggleIcon() {
        $this.toggleClass("js-collapse-toggle--open");
      }

      function toggleAriaExpanded() {
        if ($this.attr("aria-expanded") == "false") {
          $this.attr("aria-expanded", "true");
        } else if ($this.attr("aria-expanded") == "true") {
          $this.attr("aria-expanded", "false");
        }
      }

      if ($collapseBody.length !== 0) {
        $collapseBody.slideToggle(time, "swing");

        setTimeout(function() {
          switchToggleIcon();
        }, time / 2);

        setTimeout(function() {
          $collapseBody.toggleClass("collapse-bd--open");
          toggleAriaExpanded();
        }, time);

        if (typeof cb !== "undefined") {
          cb.bind($this)();
        }
      }
    });
  };

  return Collapse;
})();

/*============================================================================
  Collection page Filter menu
==============================================================================*/
theme.FilterMenu = (function() {
  // public method
  var init;

  var selectors = {
    mobileHeader: ".pt-mobile-header"
  };

  var cache = {
    $mobileHeader: $(selectors.mobileHeader)
  };

  var mediaQueryMediumDown = "screen and (max-width: 1023px)";

  init = function() {
    var $header = cache.$mobileHeader;

    new theme.Collapse(selectors.mobileHeader, "click");

    enquire.register(mediaQueryMediumDown, {
      match: function() {
        if ($header.hasClass("js-collapse-toggle--open")) {
          $header.trigger("click");
        }
      },
      unmatch: function() {
        if (!$header.hasClass("js-collapse-toggle--open")) {
          $header.trigger("click");
        }
      }
    });
  };

  return (module = {
    init: init
  });
})();

/* ================ MODULES ================ */

theme.Header = (function() {
  // var selectors = {
  //   navigation: '#AccessibleNav'
  // };

  // var config = {
  //   activeClass: 'has-active-dropdown',
  //   childLinkClass: 'site-nav__child-link'
  // };

  // var cache = {
  //   $nav: $(selectors.navigation)
  // };

  function init() {}

  function unload() {}

  return {
    init: init,
    unload: unload
  };
})();

theme.MobileNav = (function() {
  var classes = {
    open: "js-drawer-open-left"
  };

  var cache = {
    $mobileNavFooter: $(".mobile-nav__footer"),
    $mobileNavFooterClose: $(".js-mobile-nav-footer-close")
  };

  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  var mediaQueryMediumDown = "screen and (max-width: 1023px)";

  function init() {
    // init mobile nav
    var MobileNavDrawer = new theme.Drawers("MobileNavDrawer", "left", {
      open: ".js-mobile-nav-open",
      close: ".js-mobile-nav-close",
      onDrawerOpen: onMobileNavOpen
    });

    // Close mobile nav when unmatching mobile breakpoint
    enquire.register(mediaQueryMediumDown, {
      unmatch: function() {
        if ($(document.body).hasClass(classes.open)) {
          MobileNavDrawer.close.call(MobileNavDrawer);
        }
      }
    });

    // mobile nav footer close
    cache.$mobileNavFooterClose.on("click", function() {
      cache.$mobileNavFooter.removeClass("mobile-nav__footer--open");
    });
  }

  function onMobileNavOpen() {
    if (!cache.$mobileNavFooter.hasClass("mobile-nav__footer--open")) {
      cache.$mobileNavFooter.addClass("mobile-nav__footer--open");
    }
  }

  function unload() {
    // nothing to do
  }

  return {
    init: init,
    unload: unload
  };
})(jQuery);


theme.Search = (function() {
  var selectors = {
    search: ".js-search",
    searchSubmit: ".js-search .input-group__submit--left",
    searchInput: ".js-search .input-group__field",

    siteHeader: ".site-header"
  };

  var classes = {
    focus: "search--focus",
    hasContent: "js-has-content"
    // mobileNavIsOpen: 'js-menu--is-open'
  };

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    $(selectors.searchInput).on("focus", function() {
      var $searchForm = $(this).parent(),
        $searchSubmit = $(this).siblings(selectors.searchSubmit);

      $searchSubmit.prepareTransition();
      $searchForm.addClass(classes.focus);
    });

    $(selectors.searchInput).on("blur", function(evt) {
      var $searchForm = $(this).parent(),
        $searchSubmit = $(this).siblings(selectors.searchSubmit);

      $searchSubmit.prepareTransition();
      $searchForm.removeClass(classes.focus);

      if (
        evt.target.value.length == 0 &&
        $searchForm.hasClass(classes.hasContent)
      ) {
        $searchForm.removeClass(classes.hasContent);
      }
    });

    $(selectors.searchInput).on("keyup", function(evt) {
      var $searchForm = $(this).parent(),
        $searchSubmit = $(this).siblings(selectors.searchSubmit);

      $searchSubmit.prepareTransition();
      if (
        evt.target.value.length > 0 &&
        !$searchForm.hasClass(classes.hasContent)
      ) {
        $searchForm.addClass(classes.hasContent);
      } else if (
        evt.target.value.length == 0 &&
        $searchForm.hasClass(classes.hasContent)
      ) {
        $searchForm.removeClass(classes.hasContent);
      }
    });

    searchSubmit();
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  function searchSubmit() {
    $(selectors.searchSubmit).on("click", function(evt) {
      var $el = $(evt.target);
      var $input = $el.parents(selectors.search).find(selectors.searchInput);
      if ($input.val().length === 0) {
        evt.preventDefault();
        searchFocus($input);
      }
    });
  }

  return {
    init: init
  };
})();

theme.Pagination = (function() {
  function init() {
    $(".pagination__link").on("click", function(evt) {
      evt.preventDefault();
      var $this = $(this),
        query = $(this).attr("href"),
        oldQuery = window.location.search,
        newQuery;

      if (oldQuery.length) {
        newQuery = oldQuery
          .replace(/&?page=\d+/gi, "")
          .concat("&" + query)
          .replace(/\?&/, "?");
        window.location.search = newQuery;
      } else {
        window.location.search = "?" + query;
      }
    });
  }

  return {
    init: init
  };
})();

(function() {
  var selectors = {
    backButton: ".return-link"
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one("click", function(evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement("a");
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.Slideshow = (function() {
  this.$slideshow = null;
  this.sectionId;

  var classes = {
    wrapper: "slideshow-wrapper",
    slideshow: "slideshow",
    currentSlide: "slick-current",
    video: "slideshow__video",
    videoBackground: "slideshow__video--background",
    closeVideoBtn: "slideshow__video-control--close",
    pauseButton: "slideshow__pause",
    isPaused: "is-paused"
  };

  function slideshow(el) {
    var self = this;
    this.$slideshow = $(el);
    this.sectionId = el.substr(11);
    this.$wrapper = this.$slideshow.closest("." + classes.wrapper);
    this.$pause = this.$wrapper.find("." + classes.pauseButton);

    this.selectors = {
      slideshowItems:
        ".slideshow-" + this.sectionId + " .slideshow-item-wrapper"
    };

    var init = function(slickSettings) {
      if (!self.$slideshow.hasClass("slick-initialized")) {
        self.$slideshow.slick(slickSettings);
      }
    };

    var destroy = function() {
      if (self.$slideshow.hasClass("slick-initialized")) {
        self.$slideshow.slick("unslick");
      }
    };

    var slideType = !this.$slideshow.data("slideType")
      ? "scroll"
      : this.$slideshow.data("slideType");
    var slidesToShow = !this.$slideshow.data("slidesToShow")
      ? 5
      : this.$slideshow.data("slidesToShow");
    var slidesToShowSmall = !this.$slideshow.data("slidesToShowSmall")
      ? 1
      : this.$slideshow.data("slidesToShowSmall");
    var slidesToScrollSmall = !this.$slideshow.data("slidesToScrollSmall")
      ? 1
      : this.$slideshow.data("slidesToScrollSmall");
    var slidesBreakpoint =
      !this.$slideshow.data("breakpoint") ||
      this.$slideshow.data("breakpoint") == 640
        ? "none"
        : this.$slideshow.data("breakpoint") - 1;
    var slidesToScroll = !this.$slideshow.data("slidesToScroll")
      ? 2
      : this.$slideshow.data("slidesToScroll");
    var showDots = !this.$slideshow.data("showDots")
      ? false
      : this.$slideshow.data("showDots");

    // console.log('breakpoint', slidesBreakpoint);
    // console.log('type:', slideType);
    // console.log('to show:',slidesToShow);
    // console.log('to show small down:',slidesToShowSmall);
    // console.log('to scroll:',slidesToScroll);

    this.settings = {};
    this.settingsSmall = {};

    switch (slideType) {
      case "scroll":
        if (slidesBreakpoint != "none") {
          this.settings = {
            accessibility: true,
            autoplay: false,
            arrows: true,
            prevArrow: ".slider__prev--" + this.sectionId,
            nextArrow: ".slider__next--" + this.sectionId,
            infinite: true,
            dots: showDots,
            speed: 300,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            rows: 0
          };
        }

        this.settingsSmall = {
          accessibility: true,
          autoplay: false,
          arrows: true,
          prevArrow: ".slider__prev--" + this.sectionId,
          nextArrow: ".slider__next--" + this.sectionId,
          infinite: true,
          dots: showDots,
          speed: 300,
          slidesToShow: slidesToShowSmall,
          slidesToScroll: slidesToScrollSmall
        };

        break;
      case "fade":
        this.settings = {
          accessibility: true,
          arrows: true,
          dots: true,
          fade: true,
          draggable: true,
          touchThreshold: 20,
          autoplay: this.$slideshow.data("autoplay"),
          autoplaySpeed: this.$slideshow.data("speed")
        };
    }

    // responsively init/destroy slideshow
    if (slidesBreakpoint != "none") {
      var mq = window.matchMedia(
        "screen and (min-width: " + slidesBreakpoint + "px)"
      );
      var mqSmallDown = window.matchMedia("screen and (max-width: 639px)");

      // init slideshow when window size is smaller than breakpoint
      // 639 - breakpoint
      // if (!self.$slideshow.hasClass('slick-initialized') && !mq.matches && !mqSmallDown.matches) {
      //   self.$slideshow.slick(self.settings);
      // } else if (!self.$slideshow.hasClass('slick-initialized') && mqSmallDown.matches) {
      // // under 639

      // }

      enquire.register("screen and (max-width: " + slidesBreakpoint + "px)", {
        // slick under the breakpoint
        match: function() {
          init(self.settings);
        },
        // unslick above the breakpoint
        unmatch: function() {
          destroy();
        }
      });

      enquire.register("screen and (max-width: 639px)", {
        // slick using small settings under 639px
        match: function() {
          destroy();

          init(self.settingsSmall);
        },
        // slick using normal settings above 639px
        unmatch: function() {
          destroy();
          init(self.settings);
        }
      });
    } else {
      enquire.register("screen and (max-width: 639px)", {
        // slick under 639px
        match: function() {
          init(self.settingsSmall);
        },
        // unslick above 639px
        unmatch: function() {
          destroy();
        }
      });
    }

    this.$slideshow.on("beforeChange", beforeChange.bind(this));
    this.$slideshow.on("init", slideshowA11y.bind(this));
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr("aria-live");

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on("focusin", function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr("aria-live", "polite");

      if (autoplay) {
        $slider.slick("slickPause");
      }
    });

    // Resume autoplay
    $wrapper.on("focusout", function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr("aria-live");

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick("slickPlay");
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on("keydown", function(evt) {
        if (evt.which === 37) {
          $slider.slick("slickPrev");
        }

        if (evt.which === 39) {
          $slider.slick("slickNext");
        }

        // Update focus on newly selected tab
        if (evt.which === 37 || evt.which === 39) {
          obj.$dots.find(".slick-active button").focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find("." + classes.currentSlide);
    var $nextSlide = $slider.find(
      '.slideshow__slide[data-slick-index="' + nextSlide + '"]'
    );

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find("." + classes.video);
      var currentVideoId = $currentVideo.attr("id");
      theme.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr("tabindex", "-1");
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find("." + classes.video);
      var videoId = $video.attr("id");
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr("tabindex", "0");
      }
    }
  }

  function isVideoInSlide($slide) {
    return $slide.find("." + classes.video).length;
  }

  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick("slickPlay");
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick("slickPause");
    }
  };

  function getSlideshowId($el) {
    return "#Slideshow-" + $el.data("id");
  }

  return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}

theme.SlideshowVideo = (function() {
  var autoplayCheckComplete = false;
  var autoplayAvailable = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      wmode: "opaque",
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: "video-is-playing",
    paused: "video-is-paused",
    loading: "video-is-loading",
    loaded: "video-is-loaded",
    slideshowWrapper: "slideshow-wrapper",
    slide: "slideshow__slide",
    slideBackgroundVideo: "slideshow__slide--background-video",
    slideDots: "slick-dots",
    videoChrome: "slideshow__video--chrome",
    videoBackground: "slideshow__video--background",
    playVideoBtn: "slideshow__video-control--play",
    closeVideoBtn: "slideshow__video-control--close",
    currentSlide: "slick-current",
    slickClone: "slick-cloned",
    supportsAutoplay: "autoplay",
    supportsNoAutoplay: "no-autoplay"
  };

  /**
   * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr("id")] = {
      id: $video.attr("id"),
      videoId: $video.data("id"),
      type: $video.data("type"),
      status: $video.data("type") === "chrome" ? "closed" : "background", // closed, open, background
      videoSelector: $video.attr("id"),
      $parentSlide: $video.closest("." + classes.slide),
      $parentSlideshowWrapper: $video.closest("." + classes.slideshowWrapper),
      controls: $video.data("type") === "background" ? 0 : 1,
      slideshow: $video.data("slideshow")
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  function customPlayVideo(playerId) {
    // Do not autoplay just because the slideshow asked you to.
    // If the slideshow asks to play a video, make sure
    // we have done the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === "function") {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (
      videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo === "function"
    ) {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);

    initEvents();
  }

  /**
   * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $slide = videos[id].$parentSlide;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      // Play if autoplay is available or clicked to play
      $slide.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    }

    // Check for autoplay if not already done
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $slide);
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported
      ? classes.supportsAutoplay
      : classes.supportsNoAutoplay;
    $(document.documentElement).addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function autoplayCheckFunction(player, $slide) {
    // attempt to play video
    player.playVideo();

    autoplayTest(player)
      .then(function() {
        setAutoplaySupport(true);
      })
      .fail(function() {
        // No autoplay available (or took too long to start playing).
        // Show fallback image. Stop video for safety.
        setAutoplaySupport(false);
        player.stopVideo();
      })
      .always(function() {
        autoplayCheckComplete = true;
        $slide.removeClass(classes.loading);
      });
  }

  function autoplayTest(player) {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function() {
      if (player.getCurrentTime() <= 0) {
        return;
      }

      autoplayAvailable = true;
      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function() {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if ($(window).width() < 768) {
      playOnClick = true;
    } else if (window.mobileCheck()) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality("hd1080");
    var videoData = getVideoOptions(evt);

    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $("#" + videoData.id).attr("tabindex", "-1");

    sizeBackgroundVideos();

    // Customize based on options from the video ID
    switch (videoData.type) {
      case "background-chrome":
      case "background":
        evt.target.mute();
        // Only play the video if it is in the active slide
        if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
          privatePlayVideo(videoData.id);
        }
        break;
    }

    videoData.$parentSlide.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);

    switch (evt.data) {
      case 0: // ended
        setAsFinished(videoData);
        break;
      case 1: // playing
        setAsPlaying(videoData);
        break;
      case 2: // paused
        setAsPaused(videoData);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case "background":
        videoPlayers[videoData.id].seekTo(0);
        break;
      case "background-chrome":
        videoPlayers[videoData.id].seekTo(0);
        closeVideo(videoData.id);
        break;
      case "chrome":
        closeVideo(videoData.id);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    $slide.removeClass(classes.loading);

    // Do not change element visibility if it is a background video
    if (videoData.status === "background") {
      return;
    }

    $("#" + videoData.id).attr("tabindex", "0");

    switch (videoData.type) {
      case "chrome":
      case "background-chrome":
        $slideshow.removeClass(classes.paused).addClass(classes.playing);
        $slide.removeClass(classes.paused).addClass(classes.playing);
        break;
    }

    // Update focus to the close button so we stay within the slide
    $slide.find("." + classes.closeVideoBtn).focus();
  }

  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    if (videoData.type === "background-chrome") {
      closeVideo(videoData.id);
      return;
    }

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.status !== "closed" && videoData.type !== "background") {
      $slideshow.addClass(classes.paused);
      $slide.addClass(classes.paused);
    }

    if (videoData.type === "chrome" && videoData.status === "closed") {
      $slideshow.removeClass(classes.paused);
      $slide.removeClass(classes.paused);
    }

    $slideshow.removeClass(classes.playing);
    $slide.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    var classesToRemove = [classes.pause, classes.playing].join(" ");

    $("#" + videoData.id).attr("tabindex", "-1");

    videoData.status = "closed";

    switch (videoData.type) {
      case "background-chrome":
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
      case "chrome":
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
    }

    $slideshow.removeClass(classesToRemove);
    $slide.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }

  function startVideoOnClick(playerId) {
    var videoData = videos[playerId];
    // add loading class to slide
    videoData.$parentSlide.addClass(classes.loading);

    videoData.status = "open";

    switch (videoData.type) {
      case "background-chrome":
        unsetBackgroundVideo(playerId, videoData);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
      case "chrome":
        privatePlayVideo(playerId, true);
        break;
    }

    // esc to close video player
    $(document).on("keydown.videoPlayer", function(evt) {
      if (evt.keyCode === 27) {
        closeVideo(playerId);
      }
    });
  }

  function sizeBackgroundVideos() {
    $("." + classes.videoBackground).each(function(index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($player) {
    var $slide = $player.closest("." + classes.slide);
    // Ignore cloned slides
    if ($slide.hasClass(classes.slickClone)) {
      return;
    }
    var slideWidth = $slide.width();
    var playerWidth = $player.width();
    var playerHeight = $player.height();

    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
      $player
        .width(playerWidth)
        .height(playerHeight)
        .css({
          left: (slideWidth - playerWidth) / 2,
          top: 0
        }); // player width is greater, offset left; reset top
    } else {
      // new video width < window width (gap to right)
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
      $player
        .width(slideWidth)
        .height(playerHeight)
        .css({
          left: 0,
          top: (playerHeight - playerHeight) / 2
        }); // player height is greater, offset top; reset left
    }

    $player.prepareTransition().addClass(classes.loaded);
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background-chrome to a chrome-only player once played
    $("#" + playerId)
      .removeAttr("style")
      .removeClass(classes.videoBackground)
      .addClass(classes.videoChrome);

    videos[playerId].$parentSlideshowWrapper
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].$parentSlide
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].status = "open";
  }

  function setBackgroundVideo(playerId) {
    // Switch back to background-chrome when closed
    var $player = $("#" + playerId)
      .addClass(classes.videoBackground)
      .removeClass(classes.videoChrome);

    videos[playerId].$parentSlide.addClass(classes.slideBackgroundVideo);

    videos[playerId].status = "background";
    sizeBackgroundVideo($player);
  }

  function initEvents() {
    $(document).on("click.videoPlayer", "." + classes.playVideoBtn, function(
      evt
    ) {
      var playerId = $(evt.currentTarget).data("controls");
      startVideoOnClick(playerId);
    });

    $(document).on("click.videoPlayer", "." + classes.closeVideoBtn, function(
      evt
    ) {
      var playerId = $(evt.currentTarget).data("controls");
      closeVideo(playerId);
    });

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on(
      "resize.videoPlayer",
      $.debounce(250, function() {
        if (youtubeLoaded) {
          sizeBackgroundVideos();
        }
      })
    );
  }

  function removeEvents() {
    $(document).off(".videoPlayer");
    $(window).off(".videoPlayer");
  }

  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();

/* ================ TEMPLATES ================ */
(function() {
  var $filterBy = $("#BlogTagFilter");

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on("change", function() {
    location.href = $(this).val();
  });
})();

window.theme = theme || {};

theme.customerTemplates = (function() {
  function initEventListeners() {
    // Show reset password form
    $("#RecoverPassword").on("click", function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $("#HideRecoverPasswordLink").on("click", function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $("#RecoverPasswordForm").toggleClass("hide");
    $("#CustomerLoginForm").toggleClass("hide");
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $(".reset-password-success");

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $("#ResetSuccess").removeClass("hide");
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $("#AddressNewForm");

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        "AddressCountryNew",
        "AddressProvinceNew",
        {
          hideElement: "AddressProvinceContainerNew"
        }
      );
    }

    // Initialize each edit form's country/province selector
    $(".address-country-option").each(function() {
      var formId = $(this).data("form-id");
      var countrySelector = "AddressCountry_" + formId;
      var provinceSelector = "AddressProvince_" + formId;
      var containerSelector = "AddressProvinceContainer_" + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $(".address-new-toggle").on("click", function() {
      $newAddressForm.toggleClass("hide");
    });

    $(".address-edit-toggle").on("click", function() {
      var formId = $(this).data("form-id");
      $("#EditAddress_" + formId).toggleClass("hide");
    });

    $(".address-delete").on("click", function() {
      var $el = $(this);
      var formId = $el.data("form-id");
      var confirmMessage = $el.data("confirm-message");

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || "Are you sure you wish to delete this address?"
        )
      ) {
        Shopify.postLink("/account/addresses/" + formId, {
          parameters: { _method: "delete" }
        });
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === "#recover") {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();

/*================ SECTIONS ================*/

theme.Cart = (function() {
  var config = {
    showClass: "cart__update--show",
    showEditClass: "cart__edit--active",
    cartNoCookies: "cart--no-cookies"
  };

  var selectors = {
    qtyInput: ".cart__qty-input"
  };

  var cache = {
    $qtyInput: $(selectors.qtyInput)
  };

  function Cart(container) {
    this.$container = $(container);

    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies);
    }

    this._initCartQty();
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function() {},

    _initCartQty: function() {
      cache.$qtyInput.change(function() {
        $(".cart-form").trigger("submit");
      });
    },

    cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = "testcookie";
        cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();


theme.Collection = (function() {
  var constants = {
    SORT_BY: "sort_by"
  };
  var selectors = {
    filterSelection: ".filters-toolbar__input--filter",
    sortSelection: ".filters-toolbar__input--sort",
    defaultSort: ".collection-header__default-sort",
    swatchElement: ".swatch-element",
    swatchElementInput: ".swatch-element label"
  };

  function Collection(container) {
    var $container = (this.$container = $(container));

    this.$filterSelect = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.filterSelection, $container).add(
      $(selectors.sortSelection, $container)
    );
    // this.$swatchElements = $(selectors.swatchElement, $container);
    // this.$swatchElementInputs = $(selectors.swatchElementInput, $container);

    this.defaultSort = this._getDefaultSortValue();
    this._resizeSelect(this.$selects);
    this.$selects.removeClass("hidden");

    this.$filterSelect.on("change", this._onFilterChange.bind(this));
    this.$sortSelect.on("change", this._onSortChange.bind(this));

    theme.FilterMenu.init();
  }

  Collection.prototype = _.assignIn({}, Collection.prototype, {
    _onSortChange: function(evt) {
      var sort = this._sortValue();
      if (sort.length) {
        window.location.search = sort;
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = window.location.href.replace(
          window.location.search,
          ""
        );
      }
      this._resizeSelect($(evt.target));
    },

    _onFilterChange: function(evt) {
      window.location.href = this.$filterSelect.val() + window.location.search;
      this._resizeSelect($(evt.target));
    },

    _getSortValue: function() {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return $(selectors.defaultSort, this.$container).val();
    },

    _sortValue: function() {
      var sort = this._getSortValue();
      var query = "";

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + "=" + sort;
      }

      return query;
    },

    _resizeSelect: function($selection) {
      $selection.each(function() {
        var $this = $(this);
        var arrowWidth = 10;
        // create test element
        var text = $this.find("option:selected").text();
        var $test = $("<span>").html(text);

        // add to body, get width, and get out
        $test.appendTo("body");
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + arrowWidth);
      });
    },

    onUnload: function() {
      this.$filterSelect.off("change", this._onFilterChange);
      this.$sortSelect.off("change", this._onSortChange);
    }
  });

  return Collection;
})();

theme.HeaderSection = (function() {
  function Header() {
    theme.Header.init();
    theme.MobileNav.init();
    theme.Search.init();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function() {
      theme.Header.unload();
      theme.MobileNav.uload();
    }
  });

  return Header;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];
  var key = theme.mapKey ? theme.mapKey : "";

  function Map(container) {
    this.$container = $(container);

    if (apiStatus === "loaded") {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== "loading") {
        apiStatus = "loading";
        if (typeof window.google === "undefined") {
          $.getScript(
            "https://maps.googleapis.com/maps/api/js?key=" + key
          ).then(function() {
            apiStatus = "loaded";
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data("address-setting");

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$container.find(".map-section__container");

      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              disableDefaultUI: true
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter()
            });

            google.maps.event.addDomListener(
              window,
              "resize",
              $.debounce(250, function() {
                google.maps.event.trigger(map, "resize");
                map.setCenter(center);
              })
            );
          }.bind(this)
        )
        .fail(function() {
          var errorMessage;

          switch (status) {
            case "ZERO_RESULTS":
              errorMessage = theme.strings.addressNoResults;
              break;
            case "OVER_QUERY_LIMIT":
              errorMessage = theme.strings.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.addressError;
              break;
          }

          $map
            .parent()
            .addClass("page-width map-section--load-error")
            .html('<div class="errors text-center">' + errorMessage + "</div>");
        });
    },

    onUnload: function() {
      google.maps.event.clearListeners(this.map, "resize");
    }
  });

  return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  $(".map-section").addClass("map-section--load-error");
  $(".map-section__container").remove();
  $(".map-section__link").remove();
  $(".map-section__overlay").after(
    '<div class="errors text-center">' + theme.strings.authError + "</div>"
  );
}

/* eslint-disable no-new */
theme.Product = (function() {
  function Product(container) {
    var $container = (this.$container = $(container)),
      sectionId = $container.attr("data-section-id");

    this.currentVariant = {};
    this.variantsMap = {};
    this.productSingleObject = {};

    this.config = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      // mediaQueryMediumUp: 'screen and (min-width: 750px)',
      // mediaQuerySmall: 'screen and (max-width: 749px)',
      mediaQuery: "screen and (min-width: 1024px)",
      enableHistoryState: $container.data("enable-history-state") || false,
      sectionId: sectionId,
      namespace: ".product-template-" + sectionId
    };

    this.selectors = {
      productForm: ".product-form",

      addToCart: "#AddToCart-" + sectionId,
      addToCartText: "#AddToCartText-" + sectionId,
      productPrices: ".product-form__price-" + sectionId,
      comparePrice: "#ComparePrice-" + sectionId,
      comparePricemobile: "#ComparePricemobile-" + sectionId,
      originalPriceWrapper: ".product-price__price-" + sectionId,
      originalPrice: "#ProductPrice-" + sectionId,
      originalPricemobile: "#ProductPricemobile-" + sectionId,
      saleLabel: ".product-price__sale-label-" + sectionId,
      SKU: ".variant-sku-" + sectionId,
      originalSelectorId: "#ProductSelect-" + sectionId,
      singleOptionSelector: ".single-option-selector",

      swatches: ".swatch",
      swatchItems: ".swatch-element",
      swatchInputs: ".swatch-element__input",
      swatchTooltip: ".swatch-tooltip",

      productPhotosInner: ".product__photos-inner",
      productPhotosSlider: ".product__photos .slideshow",
      productPhotos: ".product__photo img",
      productZoominPhotos: ".product__photo img.js-modal-open",

      productModals: ".product-modal",
      productModalOpen: ".js-modal-open",
      productModalClose: ".js-modal-close",
      productModalZoomin: "#ProductModalZoomin-" + sectionId,
      // sizeChartTabs: ".product-modal__charts--" + sectionId + " li",
      sizeChartMainItem: '.size-chart-menu__item--has-dropdown',
      sizeChartSubItem: '.size-chart-menu__item--subitem',
      sizeChartSubmenu: '.size-chart-menu--submenu',
      sizeChartImageWrap: '.size-chart-image__image-wrapper'
    };

    this.classes = {
      unavailableAddToCart: "product-form__cart-submit--unavailable",
      saleClasse: "product-price__sale",
      activeSwatchItem: "swatch-element--active",
      soldoutSwatchItem: "swatch-element--soldout",
      soldoutBtnWrapper: "product-form__submit--soldout",
      activeModal: "modal--is-active",
      modalInner: "modal-inner"
    };

    this.cache = {
      $productForm: $(this.selectors.productForm),
      $regularPriceWrapper: $(this.selectors.regularPriceWrapper),
      $comparePriceWrapper: $(this.selectors.comparePriceWrapper),
      $comparePrice: $(this.selectors.comparePrice),
      $comparePricemobile: $(this.selectors.comparePricemobile),
      $saleLabel: $(this.selectors.saleLabel),
      $addToCart: $(this.selectors.addToCart),

      $productPhotosInner: $(
        this.selectors.productPhotosInner,
        this.$container
      ),
      $productPhotosSlider: $(
        this.selectors.productPhotosSlider,
        this.$container
      ),
      $productPhotos: $(this.selectors.productPhotos, this.$container),
      $productZoominPhotos: $(
        this.selectors.productZoominPhotos,
        this.$container
      ),

      $singleOptionSelector: $(
        this.selectors.singleOptionSelector,
        this.$container
      ),
      $swatches: $(this.selectors.swatches, this.$container),
      $swatchItems: $(this.selectors.swatchItems, this.$container),
      $swatchInputs: $(this.selectors.swatchInputs, this.$container),

      $productModals: $(this.selectors.productModals),
      $productModalOpen: $(this.selectors.productModalOpen),
      $productModalClose: $(this.selectors.productModalClose),
      $productModalZoomin: $(this.selectors.productModalZoomin),
      $sizeChartTabs: $(this.selectors.sizeChartTabs),

      $sizeChartMainItem: $(this.selectors.sizeChartMainItem),
      $sizeChartSubItem: $(this.selectors.sizeChartSubItem),
      $sizeChartSubmenu: $(this.selectors.sizeChartSubmenu),
      $sizeChartImageWrap: $(this.selectors.sizeChartImageWrap)
    };

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$("#ProductJson-" + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      document.getElementById("ProductJson-" + sectionId).innerHTML
    );
    // console.log(this.productSingleObject);

    this._preventEnterDefault();
    this._stringOverrides();
    this._initVariants();

    // enable product photos slider
    if (this.cache.$productPhotos.length > 1) {
      this._initProductPhotosSlider();
    }

    // enable product photos zoom in
    if (this.cache.$productZoominPhotos.length > 0) {
      this._initProductPhotosZoomin();
    }

    // enable size chart switch
    // this._initSizeChartSwitch();

    // size chart toggling
    this.cache.$sizeChartMainItem.on('click' + this.config.namespace, this._toggleSizeChartSubmenu.bind(this));
    this.cache.$sizeChartSubItem.on('click' + this.config.namespace, this._toggleSizeCharSubmenu.bind(this));

    // Default to first selection
    $(this.selectors.sizeChartMainItem).first().trigger('click');
    $(this.selectors.sizeChartSubItem).first().trigger('click');
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _toggleSizeChartSubmenu: function(evt) {
      var $el = $(evt.currentTarget);
      var parentData = $el.data('main-link');
      var $subMenu = $(this.selectors.sizeChartSubmenu + '[data-parent-link="' + parentData + '"]');

      // close all other size charts
      this._setSizeChartSubmenuInActive();

      this.cache.$sizeChartSubmenu.removeClass('is-active');
      this.cache.$sizeChartMainItem.removeClass('is-active');

      // set active submenu
      $el.addClass('is-active');
      $subMenu.addClass('is-active');

      // show first image
      $subMenu.find(this.selectors.sizeChartSubItem).first().trigger('click');
    },

    _toggleSizeCharSubmenu: function(evt) {
      var $el = $(evt.currentTarget);
      var imgTarget = $el.data('image-target');

      this._setSizeChartSubmenuInActive();
      // this.cache.$sizeChartSubItem.removeClass('is-active');
      $el.addClass('is-active');



      // this.cache.$sizeChartImageWrap.removeClass('is-visible');
      $(this.selectors.sizeChartImageWrap + '[data-image-parents="' + imgTarget + '"]').addClass('is-visible');
    },

    _setSizeChartSubmenuInActive: function() {
      this.cache.$sizeChartSubItem.removeClass('is-active');
      this.cache.$sizeChartImageWrap.removeClass('is-visible');
    },

    _preventEnterDefault: function() {
      this.cache.$productForm.on("keypress", function(evt) {
        if (evt.which == 13) {
          evt.preventDefault();
        }
      });
    },

    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function() {},

    _initProductPhotosSlider: function() {
      var self = this,
        options = {
          accessibility: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrow: true,
          dots: true,
          infinite: true,
          prevArrow: ".product-" + this.config.sectionId + " .slider__prev",
          nextArrow: ".product-" + this.config.sectionId + " .slider__next"
        };

      this.cache.$productPhotosSlider.slick(options);
      // show slick arrows
      $(".product-" + this.config.sectionId + " .slider__prev").removeClass(
        "hide"
      );
      $(".product-" + this.config.sectionId + " .slider__next").removeClass(
        "hide"
      );

      // filter sliders based on current color varaint
      if (this.cache.$productPhotosSlider.hasClass("slideshow--filter-color")) {
        var currentColor = this.cache.$productPhotosSlider.data(
          "current-color"
        );
        // console.log('.product__photo--'+currentColor)
        this.cache.$productPhotosSlider.slick(
          "slickFilter",
          ".product__photo--" + currentColor + ", .product__photo--none"
        );
      }

      // set the correct height of the wrapper on init
      var $currentImage = $(".slick-current", self.$container).find("img");

      if ($currentImage.length) {
        var currentImageRatio = $currentImage.data("ratio");
      } else {
        var currentImageRatio = 1;
      }

      // make the photos inner a ratio container
      this.cache.$productPhotosInner.append(
        '<style id="productPhotosWraperStyle-' +
          this.config.sectionId +
          '">.product-' +
          this.config.sectionId +
          " .product__photos-inner::before { padding-top: " +
          currentImageRatio * 100 +
          "%; }</style>"
      );

      // Change the slideshow height
      $(document).on("beforeChange", function(
        evt,
        slick,
        currentSlide,
        nextSlide
      ) {
        // scope this event
        if ($(evt.target).data("id") == self.config.sectionId) {
          var $nextImage = $(".slick-slide", self.$container)
            .eq(nextSlide + 1)
            .find("img");
          nextImageRatio = $nextImage.data("ratio");
          $("#productPhotosWraperStyle-" + self.config.sectionId + "").html(
            ".product-" +
              self.config.sectionId +
              " .product__photos-inner::before { padding-top: " +
              nextImageRatio * 100 +
              "%; }"
          );
        }
      });

      // the theme.SwatchColorValues is created at the swatch sneppets
      if (!theme.SwatchColorValues) {
        return;
      }

      if (theme.SwatchColorValues[currentColor] === "#9A9A9C") {
        this.cache.$productPhotosSlider.css(
          "background-image",
          "url(https://firebasestorage.googleapis.com/v0/b/torrid-inferno-3935.appspot.com/o/templates%2FHeather-Grey_1920x970.jpg?alt=media&token=508e67b2-62a6-4da0-b027-e39fd008346d)"
        );
      } else {
        this.cache.$productPhotosSlider.css(
          "background-color",
          theme.SwatchColorValues[currentColor]
        );
      }
    },

    _initProductPhotosZoomin: function() {
      var $photos = this.cache.$productZoominPhotos;
      var $modal = this.cache.$productModalZoomin;

      $photos.on("click", function(evt) {
        var id = $(this).data("id");
        $modal.find("img").removeClass("active");
        $modal.find('img[data-id="' + id + '"]').addClass("active");
      });
    },

    // init variants
    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState:
          this.$container.data("enable-history-state") || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      var self = this;

      var slateVariants = new slate.Variants(options);

      // init product swatch on load
      this._initSwatch(slateVariants.currentVariant);
      // check selected swatch elements availablity on load
      this._checkAvailability(slateVariants.currentVariant);

      // Bind swatch change listener
      this.cache.$swatchInputs.on(
        "change",
        this._handleSwatchOnChange.bind(this)
      );

      // update current variant
      this.$container.on("variantChange", function(evt) {
        this.currentVariant = evt.variant;
        self._checkAvailability(evt.variant);
      });

      this.$container.on("variantChange", this._updateAddToCart.bind(this));
      // this.$container.on('variantImageChange', this._updateImages.bind(this));
      this.$container.on("variantPriceChange", this._updatePrice.bind(this));
      this.$container.on("variantSKUChange", this._updateSKU.bind(this));

      // select print side back on default
      if (this.cache.$swatches.filter(".swatch--print-side").length) {
        this.cache.$swatchInputs
          .filter('[value="Back"]')
          .prop("checked", true)
          .trigger("change");
      }
    },

    // init swatches
    _initSwatch: function(currentVariant) {
      var self = this;

      // hide default single option selectors
      $.each(this.cache.$swatches, function(i, ele) {
        var $swatch = $(ele),
          optionIndex = $swatch.data("optionIndex");

        $(".selector-wrapper:eq(" + optionIndex + ")", self.$container).hide();
      });

      // check selected variants on load
      currentVariant.options.forEach(function(value, i) {
        var $swatchInput = $(
            '.swatch-element__input[value="' + value + '"]',
            this.$container
          ),
          $swatch = $swatchInput.closest(this.selectors.swatches),
          optionType = $swatch.data("optionType"),
          $swatchItem = $swatchInput.closest(this.selectors.swatchItems),
          $swatchTooltip = $swatchInput
            .closest(this.selectors.swatches)
            .find(this.selectors.swatchTooltip);

        $swatchInput.attr("checked", true);
        $swatchItem.addClass(this.classes.activeSwatchItem);

        // hide irrelevant swatchs
        if (optionType == "gender") {
          this._hideIrlvtSwatchItems($swatchInput.val());
        }

        // set tooptip value if there is one
        if ($swatchTooltip.length) {
          $swatchTooltip.html(value);
        }
      }, this);
    },

    // check swatch items availability
    _checkAvailability: function(currentVariant) {
      var available = !currentVariant ? false : currentVariant.available,
        $selectedSwatchInputs = $(
          ".swatch-element__input:checked",
          this.$container
        ),
        $selectedSwatchItems = $selectedSwatchInputs.closest(
          this.selectors.swatchItems
        );

      // reset everythingg
      this.cache.$swatchInputs.attr("disabled", false);
      this.cache.$swatchItems.removeClass(this.classes.soldoutSwatchItem);

      if (!available) {
        $selectedSwatchInputs.attr("disabled", true);
        $selectedSwatchItems.addClass(this.classes.soldoutSwatchItem);
      }
    },

    _handleSwatchOnChange: function(evt) {
      var $this = $(evt.target),
        $swatch = $this.closest(this.selectors.swatches),
        $swatchTooltip = $swatch.find(this.selectors.swatchTooltip),
        value = $this.val(),
        optionIndex = $swatch.data("optionIndex"),
        optionType = $swatch.data("optionType");

      // update active swatch element
      $swatch
        .find(this.selectors.swatchItems)
        .removeClass(this.classes.activeSwatchItem);
      $this
        .closest(this.selectors.swatchItems)
        .addClass(this.classes.activeSwatchItem);

      // change tooptip if there is one
      if ($swatchTooltip.length) {
        $swatchTooltip.html(value);
      }

      // hide irrelavent swatch items
      if (optionType == "gender") {
        this._hideIrlvtSwatchItems(value);
      }

      // update product photos
      if (optionType == "color" || optionType == "colour") {
        this._switchProductPhotos(value);
      }

      // update original selector
      this.cache.$singleOptionSelector
        .eq(optionIndex)
        .val(value)
        .trigger("change");
    },

    _hideIrlvtSwatchItems: function(master) {
      var self = this;

      // capture slaves if the master is not in the map
      if (!this.variantsMap.hasOwnProperty(master)) {
        this._captureSlaves(master);
      }

      var $slaveSwatchItems = $(
          ".swatch-element--" +
            master
              .toLowerCase()
              .split(" ")
              .join("-"),
          this.$container
        )
          .closest(".swatch")
          .siblings()
          .find(".swatch-element"),
        $activeSlave = $slaveSwatchItems.filter(".swatch-element--active");

      // reset and hide irrelavent swatch items
      $slaveSwatchItems.removeClass("hide").each(function(i, ele) {
        var $swatchItem = $(ele),
          value = $swatchItem.data("value");

        if (self.variantsMap[master].indexOf(value) == -1) {
          $swatchItem.addClass("hide");
        }
      });

      // if the active swatch is hidden, trigger click on the first one
      $.each($activeSlave, function(i, ele) {
        var $ele = $(ele);
        if ($ele.hasClass("hide")) {
          $ele
            .siblings(".swatch-element:not(.hide)")
            .eq(0)
            .find("label")
            .trigger("click");
        }
      });
    },

    // help hide irrevlant swatch items
    _captureSlaves: function(master) {
      var totalVariants = this.productSingleObject.variants;
      var slaves = [];

      // loop through current variants and store unique slaves
      var currentVariants = totalVariants
        .filter(function(variant, i) {
          return (
            variant.option1 == master ||
            variant.option2 == master ||
            variant.option3 == master
          );
        })
        .forEach(function(variant) {
          variant.options.forEach(function(option) {
            if (slaves.indexOf(option) == -1 && option != master) {
              slaves.push(option);
            }
          });
        });

      // console.log(slaves);
      this.variantsMap[master] = slaves;
    },

    // slate variant chage callback
    _updateAddToCart: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.productPrices)
          .removeClass("visibility-hidden")
          .attr("aria-hidden", "true");

        if (variant.available) {
          $(this.selectors.addToCart).prop("disabled", false);
          $(this.selectors.addToCartText).text(theme.strings.addToCart);
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart).prop("disabled", true);
          $(this.selectors.addToCartText).text(theme.strings.soldOut);
        }
      } else {
        $(this.selectors.addToCart).addClass(this.classes.unavailableAddToCart);
        // $(this.selectors.addToCart).prop('disabled', true);
        // $(this.selectors.addToCartText).text('Select All Required Variants');
        // $(this.selectors.productPrices)
        //   .addClass('visibility-hidden')
        //   .attr('aria-hidden', 'false');
      }
    },

    // slate variant chage callback
    _updatePrice: function(evt) {
      var variant = evt.variant;
      const discountedPriceElement = document.getElementById('discounted-price');
      if (discountedPriceElement) {
        const discountPercentage = parseFloat(discountedPriceElement.getAttribute('data-percentage'));
        const discountamount = discountedPriceElement.getAttribute('data-amount');
        const discounttype = discountedPriceElement.getAttribute('data-discount-type');
        const originalprice = discountedPriceElement.getAttribute('data-price');

        if(discounttype == "percent")
        {
          const multiplier = (100 - discountPercentage) / 100;
          const discountedPrice = (variant.price * multiplier * 0.01).toFixed(2);
          $(this.selectors.originalPrice).html(
            theme.Currency.formatMoney(discountedPrice, theme.moneyFormat)
          );
           $(this.selectors.originalPrice).append(
            ` <del>${theme.Currency.formatMoney(variant.price, theme.moneyFormat)}</del>`
          );
          $(this.selectors.originalPricemobile).html(
            theme.Currency.formatMoney(discountedPrice, theme.moneyFormat)
          );
           $(this.selectors.originalPricemobile).append(
            ` <del>${theme.Currency.formatMoney(variant.price, theme.moneyFormat)}</del>`
          );
        }
        else{
          const discountedPrice = ((variant.price - discountamount) * 0.01).toFixed(2);
          $(this.selectors.originalPrice).html(
            theme.Currency.formatMoney(discountedPrice, theme.moneyFormat)
          );
          $(this.selectors.originalPrice).append(
            `<del>${theme.Currency.formatMoney(variant.price, theme.moneyFormat)}</del>`
          );
          $(this.selectors.originalPricemobile).html(
            theme.Currency.formatMoney(discountedPrice, theme.moneyFormat)
          );
          $(this.selectors.originalPricemobile).append(
            `<del>${theme.Currency.formatMoney(variant.price, theme.moneyFormat)}</del>`
          );
        }
      }
      else
      {
        // Update the product price
        $(this.selectors.originalPrice).html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
        $(this.selectors.originalPricemobile).html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
      }

      // Update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
        $(this.selectors.comparePrice)
          .html(
            theme.Currency.formatMoney(
              variant.compare_at_price,
              theme.moneyFormat
            )
          )
          .removeClass("hide");

        $(this.selectors.comparePricemobile)
          .html(
            theme.Currency.formatMoney(
              variant.compare_at_price,
              theme.moneyFormat
            )
          )
          .removeClass("hide");

        $(this.selectors.originalPriceWrapper).addClass(
          this.classes.saleClasse
        );

        $(this.selectors.saleLabel).removeClass("hide");
      } else {
        $(this.selectors.comparePrice).addClass("hide");
        $(this.selectors.comparePricemobile).addClass("hide");
        $(this.selectors.saleLabel).addClass("hide");
        $(this.selectors.originalPriceWrapper).removeClass(
          this.classes.saleClasse
        );
      }
    },

    // slate variant chage callback
    _updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    // update product photos
    _switchProductPhotos: function(color) {
      var colorHandle = theme.Handleize(color),
        self = this;

      // the current image may change when switching color variants
      // so we reset the height
      var $currentImage = $(".slick-current", self.$container).find("img");

      if ($currentImage.length) {
        var currentImageRatio = $currentImage.data("ratio");
      } else {
        var currentImageRatio = 1;
      }

      $("#productPhotosWraperStyle-" + self.config.sectionId + "").html(
        ".product-" +
          self.config.sectionId +
          " .product__photos-inner::before { padding-top: " +
          currentImageRatio * 100 +
          "%; }"
      );

      // filter current color sliders
      // console.log('.product__photo--' + colorHandle)
      self.cache.$productPhotosSlider.slick("slickUnfilter");
      self.cache.$productPhotosSlider.slick(
        "slickFilter",
        ".product__photo--" + colorHandle + ", .product__photo--none"
      );

      // the theme.SwatchColorValues is created at the swatch sneppets
      // console.log('COLOR: '+theme.SwatchColorValues[colorHandle])
      if (theme.SwatchColorValues[colorHandle] === "#9A9A9C") {
        self.cache.$productPhotosSlider.css(
          "background-image",
          "url(https://firebasestorage.googleapis.com/v0/b/torrid-inferno-3935.appspot.com/o/templates%2FHeather-Grey_1920x970.jpg?alt=media&token=508e67b2-62a6-4da0-b027-e39fd008346d)"
        );
        self.cache.$productPhotosSlider.css("background-color", "none");
        //this.cache.$productPhotosSlider.css('background-image', 'url(https://firebasestorage.googleapis.com/v0/b/torrid-inferno-3935.appspot.com/o/templates%2FHeather-Grey_1920x970.jpg?alt=media&token=508e67b2-62a6-4da0-b027-e39fd008346d)');
      } else {
        //this.cache.$productPhotosSlider.css('background-color', theme.SwatchColorValues[currentColor]);
        // console.log(theme.SwatchColorValues[colorHandle])
        self.cache.$productPhotosSlider.css("background-image", "none");
        self.cache.$productPhotosSlider.css(
          "background-color",
          theme.SwatchColorValues[colorHandle]
        );
      }

      // update the current color data attribute
      // we only need this when initiating the slider, but we still update it
      self.cache.$productPhotosSlider.attr("data-current-color", colorHandle);
    },

    _initSizeChartSwitch: function() {
      var self = this;
      // console.log(this.cache.$sizeChartTabs);
      // switch size chart images
      this.cache.$sizeChartTabs.on("click", function() {
        var $this = $(this),
          $target = $($this.data("target"));

        $this.siblings(".active").removeClass("active");
        $this.addClass("active");

        $target.siblings(".active").removeClass("active");
        $target.addClass("active");
      });
    },

    onUnload: function() {
      // Do nothing since we don't have to edit this in the theme editor
    }
  });

  return Product;
})();

theme.Quotes = (function() {
  var config = {
    mediaQuerySmall: "screen and (max-width: 767px)",
    mediaQueryMediumUp: "screen and (min-width: 768px)",
    slideCount: 0
  };
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3
  };

  function Quotes(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr("data-section-id");
    var wrapper = (this.wrapper = ".quotes-wrapper");
    var slider = (this.slider = "#Quotes-" + sectionId);
    var $slider = $(slider, wrapper);

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    config.slideCount = $slider.data("count");

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on("init", this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function() {
        initSlider($slider, defaults);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick("unslick");
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick("unslick");
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $(
        ".quotes-slide--" + evt.detail.blockId + ":not(.slick-cloned)"
      );
      var slideIndex = $slide.data("slick-index");

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick("slickGoTo", slideIndex);
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr("aria-live");

      // When an element in the slider is focused set aria-live
      $wrapper.on("focusin", function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr("aria-live", "polite");
        }
      });

      // Remove aria-live
      $wrapper.on("focusout", function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr("aria-live");
        }
      });
    }
  });

  return Quotes;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr("data-section-id");
    var slideshow = (this.slideshow = "#Slideshow-" + sectionId);

    $(".slideshow__video", slideshow).each(function() {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr("id"));
    });

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $(
        ".slideshow__slide--" + evt.detail.blockId + ":not(.slick-cloned)"
      );
      var slideIndex = $slide.data("slick-index");

      // Go to selected slide, pause autoplay
      $slideshow.slick("slickGoTo", slideIndex).slick("slickPause");
    },

    onBlockDeselect: function() {
      // Resume autoplay
      $(this.slideshow).slick("slickPlay");
    }
  }
);

$(document).ready(function() {
  var sections = new theme.Sections();
  sections.register("cart-template", theme.Cart);
  sections.register("product", theme.Product);
  sections.register("collection-template", theme.Collection);
  sections.register("product-template", theme.Product);
  sections.register("header-section", theme.HeaderSection);
  sections.register("map", theme.Maps);
  sections.register("slideshow-section", theme.SlideshowSection);
  sections.register("quotes", theme.Quotes);
});

theme.init = function() {
  theme.customerTemplates.init();

  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $(".in-page-link").on("click", function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on("click", function(evt) {
    evt.preventDefault();
  });

  // init pagination
  theme.Pagination.init();

  // init modal
  theme.Modal.init();
};

$(theme.init);
